module.exports = __webpack_public_path__ + "static/media/lato-black.2bd9dcab.svg";